var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-progress',{attrs:{"percent":_vm.progress.progress_percent,"status":_vm.progress.progress_status,"format":function (percent, successPercent){ return _vm.handleProgressFormat(percent, successPercent); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }